const supportedBrands: Record<string, string> = {
  ethereum: 'coin-eth',
  rinkeby: 'coin-eth',
  bsc: 'logo-binance',
  matic: 'coin-matic',
  avalanche: 'coin-avax',
};

export const getBrandIcon = (brand: string) => supportedBrands[brand.toLowerCase()] || 'nav-failed';
